import validator from "validator";

const editPermissionValidation = (data) => {
  let errors = {};
  if (validator.isEmpty(data?.userName?.trim()))
    errors.userName = "Please enter user name";

  if (validator.isEmpty(data?.email.trim()))
    errors.email = "Please enter email address";


  if (!validator.isEmpty(data?.email) && !validator.isEmail(data.email))
    errors.email = "Email address must be valid";


  if (data?.email && !validator.isEmail(data.email))
    errors.email = "Email address must be valid";

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export default editPermissionValidation